import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Project } from '../../classes';

@Component({
  selector: 'geo-search',
  templateUrl: 'search.component.html',
  styleUrls: ['./search.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent implements OnInit {
  @Input() project: Project;

  ngOnInit() {
    if (!this.project.parameters.search) {
      this.project.parameters.search = [
        {
          type: 'address',
          name: 'По адресу',
          active: true,
          inExtent: false
        },
        {
          type: 'layer',
          name: 'По слоям',
          active: true
        },
        {
          type: 'objects',
          name: 'По объектам',
          active: true
        }
      ];
    }
  }
}
